import Vue from 'vue';
import whiteLabelTypes from '@/store/types/whiteLabel';
import serviceWaitingList from '@/helpers/apis/waitinList.js';
import MainApi from '@/helpers/apis/baseApi.js';

const state = {
  listReservationTypes: [],
  invite: false,
  allEvents: null,
  event: null,
  loader: false,
  disabledOnLog: false,
  galleries: [],
  categoriesMenu: null,
  avalibilityHour: null,
  selectedDate: null,
  selectedHour: null,
  selectedPeople: null,
  sendReservation: false,
  send705: false,
  paymentType: false,
  isFree: null,
  banks: null,
  showMenu: null,
  branch: null,
  reservationsUser: (process.browser && window.localStorage.getItem('_reservation')) ? JSON.parse(atob(window.localStorage.getItem('_reservation'))) : null,
  reservationsList: null,
  reservationsExecuted: false,
  editReservation: false,
  cancelarReservation: false,
  dataReservationEdit: {},
  minimunPeoples: null,
  times: null,
  section: null,
  showModalLogin: false,
  showModalReservationConfirm: false,
  showModalUpdateUser: false,
  showModalPolitica: false,
  loadHour: false,
  showCancelar: false,
  reservationDayUser: false,
  vendorAssociates: false,
  reservationEvent: false,
  avalabilityGroup: false,
  isAvalability: false,
  zones: false,
  selectedZone: false,
  selectedTable: null,
  selectedAdult: 0,
  selectedBoy: 0,
  selectedBaby: 0,
  selectedTypeReservation: 'Normal',
  locked: [],
  selectedExperience: null,
  eventPrice: 0,
  loginProcessReservation: false,
  popupAlertEvent: false,
  menuIdBanner: null,
  listBannersMenu: [],
  existBanner: false,
  integrations: [],
  integrationDefaults: []
};
const actions = {
  /**
   * Endpoint WhiteLabel
   */
  [whiteLabelTypes.actions.branch]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.get('branch/' + data.data.url)
        .then(response => {
          commit(whiteLabelTypes.mutations.setBranch, response.data);
          resolve(response.data);
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.suscribeToKushi]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('dashboard/subToKushki', data.data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.avalibilityHour]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.get('vendors/availability/time/' + data.data.vendorId + '/' + data.data.timestamp + '/0/' + data.data.people + '/' + data.data.zone + '/' + data.data.typeReservation + '/' + data.data.tableId)
        .then(response => {
          commit(whiteLabelTypes.mutations.setAvalibilityHour, response.data);
          resolve(response.data);
        }).catch(error => {
          reject(error);
        }).finally(() => { });
    });
  },
  [whiteLabelTypes.actions.avalibilityHourNoCommit]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.get('vendors/availability/time/' + data.data.vendorId + '/' + data.data.timestamp + '/0/' + data.data.people + '/' + data.data.zone + '/' + data.data.typeReservation + '/' + data.data.tableId)
        .then(response => {
          resolve(response.data);
        }).catch(error => {
          reject(error);
        }).finally(() => { });
    });
  },
  [whiteLabelTypes.actions.event]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.get('vendors/event/' + data.data.id)
        .then(response => {
          commit(whiteLabelTypes.mutations.setEvent, response.data);
          resolve(response.data);
        }).catch(error => { reject(error); });
    });
  },
  [whiteLabelTypes.actions.actionListBannersMenu]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.get('menuBanner/' + data.data.id)
        .then(response => {
          commit(whiteLabelTypes.mutations.setListBannersMenu, response.data.data);
          resolve(response.data);
        }).catch(error => { reject(error); });
    });
  },
  /**
   * . Endpoint WhiteLabel
   */
  [whiteLabelTypes.actions.getReservationTypes]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.get('vendors/reservationTypes/' + data.data.vendorId)
        .then(response => {
          commit(whiteLabelTypes.mutations.setReservationTypes, response.data);
          resolve(response.data);
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.allEvents]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      // Vue.axios.post('select/allEvents', data.data)
      Vue.axios.post('vendors/allEvents', data.data)
        .then(response => {
          if (response.data.code === 200) {
            commit(whiteLabelTypes.mutations.setAllEvents, response.data.data);
          }
          resolve(response.data);
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.galleries]: ({ commit }, vendor) => {
    return new Promise((resolve, reject) => {
      Vue.axios.get('vendors/gallerie/' + vendor.data.vendorId + '/1')
        .then(response => {
          commit(whiteLabelTypes.mutations.setGalleries, response.data);
          resolve(response.data);
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.categoriesMenu]: ({ commit }, vendor) => {
    return new Promise((resolve, reject) => {
      Vue.axios.get('vendors/categories/menu/' + vendor.data.vendorId)
        .then(response => {
          commit(whiteLabelTypes.mutations.setCategoriesMenu, response.data);
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.preReservation]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('reservation/preReservation', data.data)
        .then(response => {
          if (parseInt(response.data.code) === 200) {
            data.data.futureReservationsId = parseInt(response.data.futureReservations);
            data.data.vendorAvailability = response.data.vendorAvailability;
            if (data.data.id) {
              data.data.reservationId = data.data.id;
            }
            window.localStorage.setItem('_reservation', btoa(JSON.stringify(data.data)));
            commit(whiteLabelTypes.mutations.setReservationsUser);
          }
          if (parseInt(response.data.code) === 410) {
            this.$store.commit(whiteLabelTypes.mutations.setLoader, false);
          } else {
            resolve(response.data);
          }
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.preReservationEvent]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('reservation/preReservationEvent', data.data)
        .then(response => {
          if (response.data.code === 200) {
            data.data.futureReservationsId = response.data.futureReservations;
            data.data.vendorAvailability = response.data.vendorAvailability;
            window.localStorage.setItem('_reservation', btoa(JSON.stringify(data.data)));
            commit(whiteLabelTypes.mutations.setReservationsUser);
          }
          if (parseInt(response.data.code) === 410) {
            this.$store.commit(whiteLabelTypes.mutations.setLoader, false);
          } else {
            resolve(response.data);
          }
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.updatePreReservation]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('reservation/updatePreReservation', data.dat)
        .then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.confirmReservation]: (state, data) => {
    return new Promise((resolve, reject) => {
      var url = (data.reservation.isEvent) ? 'reservation/confirmReservationEvent' : 'reservation/confirmReservation';
      Vue.axios.post(url, data)
        .then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.confirmGiftCard]: (state, data) => {
    return new Promise((resolve, reject) => {
      var url = 'reservation/confirmation/giftCard';
      Vue.axios.post(url, data)
        .then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.reservationsList]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.get('reservation/user/' + data.data.userId + '/' + data.data.vendorId)
        .then(response => {
          commit(whiteLabelTypes.mutations.setReservationsList, response.data);
          resolve(response);
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.updateReservation]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.put('reservation/' + data.data.id, data.data)
        .then(response => {
          commit(whiteLabelTypes.mutations.setReservationsUser, response.data);
          resolve(response);
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.cancelarReservation]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.put('reservation/cancelar/' + data.data.id)
        .then(response => {
          commit(whiteLabelTypes.mutations.setReservationsUser, response.data);
          resolve(response);
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.cancelarReservationEmail]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.put('reservation/cancelarEmail/' + data.data.id)
        .then(response => {
          commit(whiteLabelTypes.mutations.setReservationsUser, response.data);
          resolve(response);
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.banks]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.get('vendors/pse/banks/' + data.data.vendorId)
        .then(response => {
          commit(whiteLabelTypes.mutations.setBanks, response.data);
          resolve(response);
        }).catch(error => {
          reject(error);
        });
    });
  },

  [whiteLabelTypes.actions.times]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('reservation/timeAtentionToday', data.data)
        .then(response => {
          commit(whiteLabelTypes.mutations.setTimes, response.data);
          resolve(response);
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.reservationUserDate]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.get('reservation/user/' + data.data.userId + '/' + data.data.vendorId + '/' + data.data.timestamp)
        .then(response => {
          if (parseInt(response.data.code) === 200) {
            commit(whiteLabelTypes.mutations.setReservationDayUser, true);
          }
          resolve(response.data);
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.vendorsAssociates]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.get('vendors/group/associates' + '/' + data.data.vendorId)
        .then(response => {
          commit(whiteLabelTypes.mutations.setVendorAssociates, response.data.data);
          resolve(response.data);
        }).catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.sendFormEvent]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('vendors/events', data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => { reject(error); });
    });
  },
  [whiteLabelTypes.actions.getTimesEvent]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('vendors/findEvent', data.data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => { reject(error); });
    });
  },
  [whiteLabelTypes.actions.getAvalibilityGroup]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('vendors/group/associates/availability', data)
        .then(response => {
          commit(whiteLabelTypes.mutations.setAvalabilityGroup, response.data);
          resolve(response.data);
        })
        .catch(error => { reject(error); });
    });
  },
  [whiteLabelTypes.actions.getZones]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('reservation/section/list', data)
        .then(response => {
          commit(whiteLabelTypes.mutations.setZones, response.data);
          resolve(response.data);
        })
        .catch(error => { reject(error); });
    });
  },
  [whiteLabelTypes.actions.reservationDetailById]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.get('reservation/detail/' + data.data.reservationId)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => { reject(error); });
    });
  },
  [whiteLabelTypes.actions.deletePreReservation]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.delete('reservation/preReservation/' + data.data.futureReservationsId)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => { reject(error); });
    });
  },
  [whiteLabelTypes.actions.getMaxPeople]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('reservation/getMaxPeople', data.data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => { reject(error); });
    });
  },
  [whiteLabelTypes.actions.addGiftCard]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('reservation/add/giftCard', data.data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => { reject(error); });
    });
  },
  [whiteLabelTypes.actions.getGiftCardParams]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('reservation/params/giftCard', data.data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => { reject(error); });
    });
  },
  [whiteLabelTypes.actions.validateGiftCard]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/reservation/validate/giftCard', data.data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.formMenuDigital]: (state, data) => {
    return new Promise((resolve, reject) => {
      serviceWaitingList.post('/menu/digital', data.data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.imageMenuDigital]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/gallerie', data.data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.menusMenuDigital]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/multimenu', data.data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.companions]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('global/companions', data.data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.companionUpdate]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.put('global/companions/' + data.data.id, data.data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.companionDelete]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.delete('global/companions/' + data.data.id)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.companionList]: (state, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios.get('global/companions/' + data.data.id)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.serverTime]: () => {
    return new Promise((resolve, reject) => {
      Vue.axios.post('dashboard/serverTime')
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.getIntegrations]: ({ commit }, { data }) => {
    return new Promise((resolve, reject) => {
      MainApi.get('admin/integrations/' + data.vendorId)
        .then(response => {
          commit(whiteLabelTypes.mutations.setIntegrations, response.data.data);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  [whiteLabelTypes.actions.getIntegrationDefaults]: ({ commit }, { data }) => {
    return new Promise((resolve, reject) => {
      MainApi.get('admin/integrations/null?filter=' + data.filter)
        .then(response => {
          commit(whiteLabelTypes.mutations.setIntegrationDefaults, response.data.data);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
const getters = {
  [whiteLabelTypes.getters.listReservationTypes]: state => state.listReservationTypes,
  [whiteLabelTypes.getters.invite]: state => state.invite,
  [whiteLabelTypes.getters.allEvents]: state => state.allEvents,
  [whiteLabelTypes.getters.event]: state => state.event,
  [whiteLabelTypes.getters.loader]: state => state.loader,
  [whiteLabelTypes.getters.disabledOnLog]: state => state.disabledOnLog,
  [whiteLabelTypes.getters.galleries]: state => state.galleries,
  [whiteLabelTypes.getters.categoriesMenu]: state => state.categoriesMenu,
  [whiteLabelTypes.getters.avalibilityHour]: state => state.avalibilityHour,
  [whiteLabelTypes.getters.selectedDate]: state => state.selectedDate,
  [whiteLabelTypes.getters.selectedHour]: state => state.selectedHour,
  [whiteLabelTypes.getters.selectedPeople]: state => state.selectedPeople,
  [whiteLabelTypes.getters.sendReservation]: state => state.sendReservation,
  [whiteLabelTypes.getters.send705]: state => state.send705,
  [whiteLabelTypes.getters.paymentType]: state => state.paymentType,
  [whiteLabelTypes.getters.isFree]: state => state.isFree,
  [whiteLabelTypes.getters.banks]: state => state.banks,
  [whiteLabelTypes.getters.showMenu]: state => state.showMenu,
  [whiteLabelTypes.getters.branch]: state => state.branch,
  [whiteLabelTypes.getters.reservationsUser]: state => state.reservationsUser,
  [whiteLabelTypes.getters.reservationsList]: state => state.reservationsList,
  [whiteLabelTypes.getters.reservationsExecuted]: state => state.reservationsExecuted,
  [whiteLabelTypes.getters.editReservation]: state => state.editReservation,
  [whiteLabelTypes.getters.cancelarReservation]: state => state.cancelarReservation,
  [whiteLabelTypes.getters.dataReservationEdit]: state => state.dataReservationEdit,
  [whiteLabelTypes.getters.minimunPeoples]: state => state.minimunPeoples,
  [whiteLabelTypes.getters.times]: state => state.times,
  [whiteLabelTypes.getters.section]: state => state.section,
  [whiteLabelTypes.getters.showModalLogin]: state => state.showModalLogin,
  [whiteLabelTypes.getters.showModalReservationConfirm]: state => state.showModalReservationConfirm,
  [whiteLabelTypes.getters.showModalUpdateUser]: state => state.showModalUpdateUser,
  [whiteLabelTypes.getters.showModalPolitica]: state => state.showModalPolitica,
  [whiteLabelTypes.getters.loadHour]: state => state.loadHour,
  [whiteLabelTypes.getters.showCancelar]: state => state.showCancelar,
  [whiteLabelTypes.getters.reservationDayUser]: state => state.reservationDayUser,
  [whiteLabelTypes.getters.reservationEvent]: state => state.reservationEvent,
  [whiteLabelTypes.getters.getVendorAssociates]: state => state.vendorAssociates,
  [whiteLabelTypes.getters.avalabilityGroup]: state => state.avalabilityGroup,
  [whiteLabelTypes.getters.isAvalability]: state => state.isAvalability,
  [whiteLabelTypes.getters.zones]: state => state.zones,
  [whiteLabelTypes.getters.selectedZone]: state => state.selectedZone,
  [whiteLabelTypes.getters.selectedTable]: state => state.selectedTable,
  [whiteLabelTypes.getters.selectedAdult]: state => state.selectedAdult,
  [whiteLabelTypes.getters.selectedBoy]: state => state.selectedBoy,
  [whiteLabelTypes.getters.selectedBaby]: state => state.selectedBaby,
  [whiteLabelTypes.getters.selectedTypeReservation]: state => state.selectedTypeReservation,
  [whiteLabelTypes.getters.locked]: state => state.locked,
  [whiteLabelTypes.getters.selectedExperience]: state => state.selectedExperience,
  [whiteLabelTypes.getters.eventPrice]: state => state.eventPrice,
  [whiteLabelTypes.getters.loginProcessReservation]: state => state.loginProcessReservation,
  [whiteLabelTypes.getters.popupAlertEvent]: state => state.popupAlertEvent,
  [whiteLabelTypes.getters.getMenuIdBanner]: state => state.menuIdBanner,
  [whiteLabelTypes.getters.getListBannersMenu]: state => state.listBannersMenu,
  [whiteLabelTypes.getters.getExistBanner]: state => state.existBanner,
  [whiteLabelTypes.getters.integrations]: state => state.integrations,
  [whiteLabelTypes.getters.integrationDefaults]: state => state.integrationDefaults
};
const mutations = {
  [whiteLabelTypes.mutations.setSelectedAdult] (state, data) {
    state.selectedAdult = data;
  },
  [whiteLabelTypes.mutations.setSelectedBoy] (state, data) {
    state.selectedBoy = data;
  },
  [whiteLabelTypes.mutations.setSelectedBaby] (state, data) {
    state.selectedBaby = data;
  },
  [whiteLabelTypes.mutations.setSelectedTypeReservation] (state, data) {
    state.selectedTypeReservation = data;
  },
  [whiteLabelTypes.mutations.setReservationTypes] (state, data) {
    state.listReservationTypes = data;
  },
  [whiteLabelTypes.mutations.setInvite] (state, data) {
    state.invite = data;
  },
  [whiteLabelTypes.mutations.setAllEvents] (state, data) {
    state.allEvents = data;
  },
  [whiteLabelTypes.mutations.setEvent] (state, data) {
    state.event = data;
  },
  [whiteLabelTypes.mutations.setLoader] (state, loader) {
    state.loader = loader;
  },
  [whiteLabelTypes.mutations.setDisabledOnLog] (state, disabledOnLog) {
    state.disabledOnLog = disabledOnLog;
  },
  [whiteLabelTypes.mutations.setGalleries] (state, galleries) {
    state.galleries = galleries;
  },
  [whiteLabelTypes.mutations.setCategoriesMenu] (state, categoriesMenu) {
    state.categoriesMenu = categoriesMenu;
  },
  [whiteLabelTypes.mutations.setAvalibilityHour] (state, avalibilityHour) {
    state.avalibilityHour = avalibilityHour;
  },
  [whiteLabelTypes.mutations.setSelectedDate] (state, selectedDate) {
    state.selectedDate = selectedDate;
  },
  [whiteLabelTypes.mutations.setSelectedHour] (state, selectedHour) {
    state.selectedHour = selectedHour;
  },
  [whiteLabelTypes.mutations.setSelectedPeople] (state, selectedPeople) {
    state.selectedPeople = selectedPeople;
  },
  [whiteLabelTypes.mutations.setSendReservation] (state, sendReservation) {
    state.sendReservation = sendReservation;
  },
  [whiteLabelTypes.mutations.setSend705] (state, send705) {
    state.send705 = send705;
  },
  [whiteLabelTypes.mutations.setPaymentType] (state, paymentType) {
    state.paymentType = paymentType; // payment method (1 => credit card, 2 => pse)
  },
  [whiteLabelTypes.mutations.setIsFree] (state, isFree) {
    state.isFree = isFree;
  },
  [whiteLabelTypes.mutations.setBanks] (state, banks) {
    state.banks = banks;
  },
  [whiteLabelTypes.mutations.setShowMenu] (state, showMenu) {
    state.showMenu = showMenu;
  },
  [whiteLabelTypes.mutations.setBranch] (state, branch) {
    state.branch = branch;
  },
  [whiteLabelTypes.mutations.setReservationsUser] (state) {
    state.reservationsUser = (process.browser && window.localStorage.getItem('_reservation')) ? JSON.parse(atob(window.localStorage.getItem('_reservation'))) : {};
  },
  [whiteLabelTypes.mutations.setReservationsList] (state, reservationsList) {
    state.reservationsList = reservationsList;
  },
  [whiteLabelTypes.mutations.setEditReservation] (state, editReservation) {
    state.editReservation = editReservation;
  },
  [whiteLabelTypes.mutations.setReservationsExecuted] (state, reservationsExecuted) {
    state.reservationsExecuted = reservationsExecuted;
  },
  [whiteLabelTypes.mutations.setCancelarReservation] (state, cancelarReservation) {
    state.cancelarReservation = cancelarReservation;
  },
  [whiteLabelTypes.mutations.setDataReservationEdit] (state, dataReservationEdit) {
    state.dataReservationEdit = dataReservationEdit;
  },
  [whiteLabelTypes.mutations.setMinimunPeoples] (state, minimunPeoples) {
    state.minimunPeoples = minimunPeoples;
  },
  [whiteLabelTypes.mutations.setTimes] (state, times) {
    state.times = times;
  },
  [whiteLabelTypes.mutations.setSection] (state, section) {
    state.section = section;
  },
  [whiteLabelTypes.mutations.setShowModalLogin] (state, showModalLogin) {
    state.showModalLogin = showModalLogin;
  },
  [whiteLabelTypes.mutations.setShowModalReservationConfirm] (state) {
    state.showModalReservationConfirm = !!((process.browser && window.localStorage.getItem('_reservationOk')));
  },
  [whiteLabelTypes.mutations.setShowModalUpdateUser] (state, showModalUpdateUser) {
    state.showModalUpdateUser = showModalUpdateUser;
  },
  [whiteLabelTypes.mutations.setShowModalPolitica] (state, showModalPolitica) {
    state.showModalPolitica = showModalPolitica;
  },
  [whiteLabelTypes.mutations.setLoadHour] (state, loadHour) {
    state.loadHour = loadHour;
  },
  [whiteLabelTypes.mutations.setShowCancelar] (state, showCancelar) {
    state.showCancelar = showCancelar;
  },
  [whiteLabelTypes.mutations.setReservationDayUser] (state, reservationDayUser) {
    state.reservationDayUser = reservationDayUser;
  },
  [whiteLabelTypes.mutations.setVendorAssociates] (state, data) {
    state.vendorAssociates = data;
  },
  [whiteLabelTypes.mutations.setReservationEvent] (state, data) {
    state.reservationEvent = data;
  },
  [whiteLabelTypes.mutations.setAvalabilityGroup] (state, data) {
    state.avalabilityGroup = data;
  },
  [whiteLabelTypes.mutations.setIsAvalability] (state, data) {
    state.isAvalability = data;
  },
  [whiteLabelTypes.mutations.setZones] (state, data) {
    state.zones = data;
  },
  [whiteLabelTypes.mutations.setSelectedZone] (state, data) {
    state.selectedZone = data;
  },
  [whiteLabelTypes.mutations.setSelectedTable] (state, data) {
    state.selectedTable = data;
  },
  [whiteLabelTypes.mutations.setLocked] (state, data) {
    state.locked = data;
  },
  [whiteLabelTypes.mutations.setSelectedExperience] (state, data) {
    state.selectedExperience = data;
  },
  [whiteLabelTypes.mutations.setEventPrice] (state, data) {
    state.eventPrice = data;
  },
  [whiteLabelTypes.mutations.setLoginProcessReservation] (state, data) {
    state.loginProcessReservation = data;
  },
  [whiteLabelTypes.mutations.setPopupAlertEvent] (state, data) {
    state.popupAlertEvent = data;
  },
  [whiteLabelTypes.mutations.setMenuIdBanner] (state, data) {
    state.menuIdBanner = data;
  },
  [whiteLabelTypes.mutations.setListBannersMenu] (state, data) {
    state.listBannersMenu = data;
  },
  [whiteLabelTypes.mutations.setExistBanner] (state, data) {
    state.existBanner = data;
  },
  [whiteLabelTypes.mutations.setIntegrations] (state, integrations) {
    state.integrations = integrations;
  },
  [whiteLabelTypes.mutations.setIntegrationDefaults] (state, integrationDefaults) {
    state.integrationDefaults = integrationDefaults;
  }
};
export default {
  state,
  actions,
  getters,
  mutations
};
